@if (status() === CloudStorageStatus.Active) {
  <div
    class="tablet:flex tablet:flex-row-reverse"
    [attr.aria-labelledby]="'cloud-storage-banner-title-' + data().id"
  >
    <div
      class="h-[300px] flex justify-center items-center desktop:min-w-[384px] tablet:h-auto tablet:w-1/2 relative"
    >
      <div
        class="absolute top-0 left-0 right-0 bottom-0 bg-center bg-cover"
        [style.backgroundImage]="getBackgroundStyle()"
      ></div>
      <h2
        class="font-headline text-5xl text-white text-center w-[280px] leading-[57px] banner-title"
        [attr.data-title]="data().primaryTitle"
        [id]="'cloud-storage-banner-title-' + data().id"
      >
        {{ data().primaryTitle }}
      </h2>
    </div>
    <div
      [style.backgroundColor]="data().secondaryBackgroundColor"
      class="bg-primaryRed p-8 tablet:p-10 desktop:p-12 desktop:min-w-[510px] tablet:w-1/2"
    >
      <div class="mb-3 flex tablet:items-center">
        @if (data().storageIcon) {
          <img
            [src]="data().storageIcon.url | scCmsImage"
            class="mr-4 hidden desktop:block tablet:mr-5 desktop:mr-6 min-w-fit h-full"
            alt=""
          />
        }
        <div
          class="text-mobileH2 tablet:text-tabletH2 font-semibold desktop:text-desktopH2 text-white font-headline"
        >
          {{ data().secondaryTitle }}
        </div>
      </div>
      <p
        class="leading-5 tablet:leading-5 text-mobileMd tablet:text-tabletMd desktop:text-desktopMd desktop:leading-5 text-white"
        [innerHTML]="data().secondarySubTitleActive"
      ></p>
      <sc-button
        variant="white"
        url="{{ data().primaryButtonUrlActive }}"
        class="block mt-10 tablet:mt-11 desktop:mt-12 tablet:w-fit"
      >
        <span>{{ data().primaryButtonTitleActive }}</span>
      </sc-button>
    </div>
  </div>
} @else {
  <div
    class="tablet:flex tablet:flex-row-reverse"
    [attr.aria-labelledby]="'cloud-storage-banner-title-' + data().id"
  >
    <div
      class="h-[300px] flex justify-center items-center desktop:min-w-[384px] tablet:h-auto tablet:w-1/2 relative"
    >
      <div
        class="absolute top-0 left-0 right-0 bottom-0 bg-center bg-cover"
        [style.backgroundImage]="getBackgroundStyle()"
      ></div>
      <h2
        class="font-headline text-5xl text-white text-center w-[280px] leading-[57px] banner-title"
        [attr.data-title]="data().primaryTitle"
        [id]="'cloud-storage-banner-title-' + data().id"
      >
        {{ data().primaryTitle }}
      </h2>
    </div>
    <div
      [style.backgroundColor]="data().secondaryBackgroundColor"
      class="bg-primaryRed p-8 tablet:p-10 desktop:p-12 desktop:min-w-[510px] tablet:w-1/2"
    >
      <div class="mb-3 flex tablet:items-center">
        @if (data().storageIcon) {
          <img
            [src]="data().storageIcon.url | scCmsImage"
            class="mr-4 hidden desktop:block tablet:mr-5 desktop:mr-6 min-w-fit h-full"
            alt=""
          />
        }
        <div
          class="text-mobileH2 tablet:text-tabletH2 font-semibold desktop:text-desktopH2 text-white font-headline"
        >
          {{ data().secondaryTitle }}
        </div>
      </div>
      <p
        class="leading-5 tablet:leading-5 text-mobileMd tablet:text-tabletMd desktop:text-desktopMd desktop:leading-5 text-white"
        [innerHTML]="data().secondarySubTitleInactive"
      ></p>
      <div
        class="mb-9 flex justify-normal gap-2.5 items-center relative desktop:mb-12 text-white mt-3"
      >
        <div class="flex w-[100px] justify-around items-center">
          <div class="text-mobileH3 tablet:text-tabletH3 font-headline desktop:text-desktopH3">
            {{ storagePrice() + '' }}
          </div>
          <div class="w-[32px] text-sm font-extrabold font-headline text-[12px] leading-[14px]">
            {{ data().price }}
          </div>
        </div>
        <div class="min-w-[3px] border-x-black border-x-[1px] h-7"></div>
        <div class="text-mobileH3 tablet:text-tabletH3 font-headline desktop:text-desktopH3">
          {{ data().priceWithDiscount }}
        </div>
        <div
          class="absolute top-[17px] left-0 w-24 h-[1px] bg-black transform rotate-[346deg]"
        ></div>
      </div>
      <div class="mb-4 desktop:flex tablet:mb-5 desktop:mb-6 desktop:gap-2">
        @if (createAccountUrl()) {
          <a
            [href]="createAccountUrl()"
            target="_self"
            class="flex justify-center items-center w-full text-center cursor-pointer font-semibold bg-white text-black rounded-full h-10 text-mobileMd tablet:text-tabletMd desktop:text-desktopMd mb-3 desktop:mb-0 tablet:font-semibold desktop:font-semibold"
            >{{ data().primaryButtonTitleInactive }}</a
          >
          <a
            [href]="data().secondaryButtonUrlInactive"
            target="_blank"
            class="flex justify-center items-center w-full border border-white text-white rounded-full h-10 text-mobileMd tablet:text-tabletMd desktop:text-desktopMd tablet:font-semibold desktop:font-semibold"
            >{{ data().secondaryButtonTitleInactive }}</a
          >
        }
      </div>
      <p class="font-normal text-xs text-white">{{ data().info }}</p>
    </div>
  </div>
}
